
export function showElements(els) {
  for (let i = 0; i < els.length; i++) {
    els[i].draw();
  }
}
